export default "__VITE_ASSET__D5UIXw7___"